import React from 'react';

export const Header = (props) => {
    return (
        <div className="header">
            <h1>Getting Started With React</h1>
        </div>
    )
}